"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 9.4.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rqd2QuerierApi = exports.Rqd2QuerierApiFactory = exports.Rqd2QuerierApiFp = exports.Rqd2QuerierApiAxiosParamCreator = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("../common");
// @ts-ignore
var base_1 = require("../base");
/**
 * Rqd2QuerierApi - axios parameter creator
 * @export
 */
var Rqd2QuerierApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get information about the query service health.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuerierServiceHealth: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/rqd2/querier/health";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about the query service readiness.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuerierServiceReady: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/rqd2/querier/ready";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Search for text in attachments of specified Requisition.
         * @param {number} rqid
         * @param {string} searchValue
         * @param {'EXACT_MATCH' | 'FUZZY' | 'WILDCARD'} [searchType] Specify EXACT_MATCH for exact matching search value, FUZZY for fuzzy search (similar texts could match) or WILDCARD for search with wildcards pattern using * and ?
         * @param {'POSITION' | 'SCORE'} [sortBy] Results sort order, could be POSITION to sort bounding boxes by their position inside the page or SCORE to sort by the search result score. Defaults to no specific order.
         * @param {boolean} [includesHighlights] Specify if the search result should include an additional highlights field for each match showing the matching terms enclosed in an em tag (e.g. \&#39;text matching_text more text\&#39;)
         * @param {boolean} [includesSpans] Specify if the search result should include an additional spans field for each match showing the list of matching terms with the range where it appears (e.g. { \&#39;term\&#39;: \&#39;matching_text\&#39;, \&#39;range\&#39;: \&#39;5-17\&#39; }).
         * @param {string} [correlationId] UUID that can be tracked across requests.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAttachments: function (rqid, searchValue, searchType, sortBy, includesHighlights, includesSpans, correlationId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rqid' is not null or undefined
                            (0, common_1.assertParamExists)('searchAttachments', 'rqid', rqid);
                            // verify required parameter 'searchValue' is not null or undefined
                            (0, common_1.assertParamExists)('searchAttachments', 'searchValue', searchValue);
                            localVarPath = "/rqd2/querier/search";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            if (rqid !== undefined) {
                                localVarQueryParameter['rqid'] = rqid;
                            }
                            if (searchValue !== undefined) {
                                localVarQueryParameter['searchValue'] = searchValue;
                            }
                            if (searchType !== undefined) {
                                localVarQueryParameter['searchType'] = searchType;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (includesHighlights !== undefined) {
                                localVarQueryParameter['includesHighlights'] = includesHighlights;
                            }
                            if (includesSpans !== undefined) {
                                localVarQueryParameter['includesSpans'] = includesSpans;
                            }
                            if (correlationId !== undefined) {
                                localVarQueryParameter['correlationId'] = correlationId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Structured Search of Requisitions
         * @param {number} rqid
         * @param {string} userId
         * @param {string} [correlationId] UUID that can be tracked across requests.
         * @param {Array<string>} [entities]
         * @param {number} [threshold]
         * @param {number} [matches]
         * @param {'SCALED_PRODUCTS' | 'WEIGHTED_AVERAGE'} [sortBy]     This specifies how to rank and sort the values inside each label. It could be:       - &#x60;SCALED_PRODUCTS&#x60;: ranks computing the product of all the parameters:       &#x60;confidence * occurrence_count * has_normalized_text&#x60;       - &#x60;WEIGHTED_AVERAGE&#x60;: ranks using a different configured weight for each parameter:       &#x60;confidence * confidence_weight + occurrences * occurrences_weight + has_normalized_text * has_normalized_text_weight &#x60;       *IMPORTANT*: Computed scores are scaled to 1 (i.e. the max result in the label is scaled to 1, and the remaining results are scaled proportionally).
         * @param {boolean} [includeBoxes]
         * @param {boolean} [includeTokens]
         * @param {boolean} [includeModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        structuredSearch: function (rqid, userId, correlationId, entities, threshold, matches, sortBy, includeBoxes, includeTokens, includeModel, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rqid' is not null or undefined
                            (0, common_1.assertParamExists)('structuredSearch', 'rqid', rqid);
                            // verify required parameter 'userId' is not null or undefined
                            (0, common_1.assertParamExists)('structuredSearch', 'userId', userId);
                            localVarPath = "/rqd2/querier/structured_search";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            if (rqid !== undefined) {
                                localVarQueryParameter['rqid'] = rqid;
                            }
                            if (userId !== undefined) {
                                localVarQueryParameter['userId'] = userId;
                            }
                            if (correlationId !== undefined) {
                                localVarQueryParameter['correlationId'] = correlationId;
                            }
                            if (entities) {
                                localVarQueryParameter['entities'] = entities;
                            }
                            if (threshold !== undefined) {
                                localVarQueryParameter['threshold'] = threshold;
                            }
                            if (matches !== undefined) {
                                localVarQueryParameter['matches'] = matches;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (includeBoxes !== undefined) {
                                localVarQueryParameter['includeBoxes'] = includeBoxes;
                            }
                            if (includeTokens !== undefined) {
                                localVarQueryParameter['includeTokens'] = includeTokens;
                            }
                            if (includeModel !== undefined) {
                                localVarQueryParameter['includeModel'] = includeModel;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.Rqd2QuerierApiAxiosParamCreator = Rqd2QuerierApiAxiosParamCreator;
/**
 * Rqd2QuerierApi - functional programming interface
 * @export
 */
var Rqd2QuerierApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.Rqd2QuerierApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get information about the query service health.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuerierServiceHealth: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getQuerierServiceHealth(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about the query service readiness.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuerierServiceReady: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getQuerierServiceReady(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Search for text in attachments of specified Requisition.
         * @param {number} rqid
         * @param {string} searchValue
         * @param {'EXACT_MATCH' | 'FUZZY' | 'WILDCARD'} [searchType] Specify EXACT_MATCH for exact matching search value, FUZZY for fuzzy search (similar texts could match) or WILDCARD for search with wildcards pattern using * and ?
         * @param {'POSITION' | 'SCORE'} [sortBy] Results sort order, could be POSITION to sort bounding boxes by their position inside the page or SCORE to sort by the search result score. Defaults to no specific order.
         * @param {boolean} [includesHighlights] Specify if the search result should include an additional highlights field for each match showing the matching terms enclosed in an em tag (e.g. \&#39;text matching_text more text\&#39;)
         * @param {boolean} [includesSpans] Specify if the search result should include an additional spans field for each match showing the list of matching terms with the range where it appears (e.g. { \&#39;term\&#39;: \&#39;matching_text\&#39;, \&#39;range\&#39;: \&#39;5-17\&#39; }).
         * @param {string} [correlationId] UUID that can be tracked across requests.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAttachments: function (rqid, searchValue, searchType, sortBy, includesHighlights, includesSpans, correlationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.searchAttachments(rqid, searchValue, searchType, sortBy, includesHighlights, includesSpans, correlationId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Structured Search of Requisitions
         * @param {number} rqid
         * @param {string} userId
         * @param {string} [correlationId] UUID that can be tracked across requests.
         * @param {Array<string>} [entities]
         * @param {number} [threshold]
         * @param {number} [matches]
         * @param {'SCALED_PRODUCTS' | 'WEIGHTED_AVERAGE'} [sortBy]     This specifies how to rank and sort the values inside each label. It could be:       - &#x60;SCALED_PRODUCTS&#x60;: ranks computing the product of all the parameters:       &#x60;confidence * occurrence_count * has_normalized_text&#x60;       - &#x60;WEIGHTED_AVERAGE&#x60;: ranks using a different configured weight for each parameter:       &#x60;confidence * confidence_weight + occurrences * occurrences_weight + has_normalized_text * has_normalized_text_weight &#x60;       *IMPORTANT*: Computed scores are scaled to 1 (i.e. the max result in the label is scaled to 1, and the remaining results are scaled proportionally).
         * @param {boolean} [includeBoxes]
         * @param {boolean} [includeTokens]
         * @param {boolean} [includeModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        structuredSearch: function (rqid, userId, correlationId, entities, threshold, matches, sortBy, includeBoxes, includeTokens, includeModel, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.structuredSearch(rqid, userId, correlationId, entities, threshold, matches, sortBy, includeBoxes, includeTokens, includeModel, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.Rqd2QuerierApiFp = Rqd2QuerierApiFp;
/**
 * Rqd2QuerierApi - factory interface
 * @export
 */
var Rqd2QuerierApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.Rqd2QuerierApiFp)(configuration);
    return {
        /**
         *
         * @summary Get information about the query service health.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuerierServiceHealth: function (options) {
            return localVarFp.getQuerierServiceHealth(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get information about the query service readiness.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuerierServiceReady: function (options) {
            return localVarFp.getQuerierServiceReady(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Search for text in attachments of specified Requisition.
         * @param {number} rqid
         * @param {string} searchValue
         * @param {'EXACT_MATCH' | 'FUZZY' | 'WILDCARD'} [searchType] Specify EXACT_MATCH for exact matching search value, FUZZY for fuzzy search (similar texts could match) or WILDCARD for search with wildcards pattern using * and ?
         * @param {'POSITION' | 'SCORE'} [sortBy] Results sort order, could be POSITION to sort bounding boxes by their position inside the page or SCORE to sort by the search result score. Defaults to no specific order.
         * @param {boolean} [includesHighlights] Specify if the search result should include an additional highlights field for each match showing the matching terms enclosed in an em tag (e.g. \&#39;text matching_text more text\&#39;)
         * @param {boolean} [includesSpans] Specify if the search result should include an additional spans field for each match showing the list of matching terms with the range where it appears (e.g. { \&#39;term\&#39;: \&#39;matching_text\&#39;, \&#39;range\&#39;: \&#39;5-17\&#39; }).
         * @param {string} [correlationId] UUID that can be tracked across requests.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAttachments: function (rqid, searchValue, searchType, sortBy, includesHighlights, includesSpans, correlationId, options) {
            return localVarFp.searchAttachments(rqid, searchValue, searchType, sortBy, includesHighlights, includesSpans, correlationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Structured Search of Requisitions
         * @param {number} rqid
         * @param {string} userId
         * @param {string} [correlationId] UUID that can be tracked across requests.
         * @param {Array<string>} [entities]
         * @param {number} [threshold]
         * @param {number} [matches]
         * @param {'SCALED_PRODUCTS' | 'WEIGHTED_AVERAGE'} [sortBy]     This specifies how to rank and sort the values inside each label. It could be:       - &#x60;SCALED_PRODUCTS&#x60;: ranks computing the product of all the parameters:       &#x60;confidence * occurrence_count * has_normalized_text&#x60;       - &#x60;WEIGHTED_AVERAGE&#x60;: ranks using a different configured weight for each parameter:       &#x60;confidence * confidence_weight + occurrences * occurrences_weight + has_normalized_text * has_normalized_text_weight &#x60;       *IMPORTANT*: Computed scores are scaled to 1 (i.e. the max result in the label is scaled to 1, and the remaining results are scaled proportionally).
         * @param {boolean} [includeBoxes]
         * @param {boolean} [includeTokens]
         * @param {boolean} [includeModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        structuredSearch: function (rqid, userId, correlationId, entities, threshold, matches, sortBy, includeBoxes, includeTokens, includeModel, options) {
            return localVarFp.structuredSearch(rqid, userId, correlationId, entities, threshold, matches, sortBy, includeBoxes, includeTokens, includeModel, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.Rqd2QuerierApiFactory = Rqd2QuerierApiFactory;
/**
 * Rqd2QuerierApi - object-oriented interface
 * @export
 * @class Rqd2QuerierApi
 * @extends {BaseAPI}
 */
var Rqd2QuerierApi = /** @class */ (function (_super) {
    __extends(Rqd2QuerierApi, _super);
    function Rqd2QuerierApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get information about the query service health.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Rqd2QuerierApi
     */
    Rqd2QuerierApi.prototype.getQuerierServiceHealth = function (options) {
        var _this = this;
        return (0, exports.Rqd2QuerierApiFp)(this.configuration).getQuerierServiceHealth(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get information about the query service readiness.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Rqd2QuerierApi
     */
    Rqd2QuerierApi.prototype.getQuerierServiceReady = function (options) {
        var _this = this;
        return (0, exports.Rqd2QuerierApiFp)(this.configuration).getQuerierServiceReady(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Search for text in attachments of specified Requisition.
     * @param {number} rqid
     * @param {string} searchValue
     * @param {'EXACT_MATCH' | 'FUZZY' | 'WILDCARD'} [searchType] Specify EXACT_MATCH for exact matching search value, FUZZY for fuzzy search (similar texts could match) or WILDCARD for search with wildcards pattern using * and ?
     * @param {'POSITION' | 'SCORE'} [sortBy] Results sort order, could be POSITION to sort bounding boxes by their position inside the page or SCORE to sort by the search result score. Defaults to no specific order.
     * @param {boolean} [includesHighlights] Specify if the search result should include an additional highlights field for each match showing the matching terms enclosed in an em tag (e.g. \&#39;text matching_text more text\&#39;)
     * @param {boolean} [includesSpans] Specify if the search result should include an additional spans field for each match showing the list of matching terms with the range where it appears (e.g. { \&#39;term\&#39;: \&#39;matching_text\&#39;, \&#39;range\&#39;: \&#39;5-17\&#39; }).
     * @param {string} [correlationId] UUID that can be tracked across requests.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Rqd2QuerierApi
     */
    Rqd2QuerierApi.prototype.searchAttachments = function (rqid, searchValue, searchType, sortBy, includesHighlights, includesSpans, correlationId, options) {
        var _this = this;
        return (0, exports.Rqd2QuerierApiFp)(this.configuration).searchAttachments(rqid, searchValue, searchType, sortBy, includesHighlights, includesSpans, correlationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Structured Search of Requisitions
     * @param {number} rqid
     * @param {string} userId
     * @param {string} [correlationId] UUID that can be tracked across requests.
     * @param {Array<string>} [entities]
     * @param {number} [threshold]
     * @param {number} [matches]
     * @param {'SCALED_PRODUCTS' | 'WEIGHTED_AVERAGE'} [sortBy]     This specifies how to rank and sort the values inside each label. It could be:       - &#x60;SCALED_PRODUCTS&#x60;: ranks computing the product of all the parameters:       &#x60;confidence * occurrence_count * has_normalized_text&#x60;       - &#x60;WEIGHTED_AVERAGE&#x60;: ranks using a different configured weight for each parameter:       &#x60;confidence * confidence_weight + occurrences * occurrences_weight + has_normalized_text * has_normalized_text_weight &#x60;       *IMPORTANT*: Computed scores are scaled to 1 (i.e. the max result in the label is scaled to 1, and the remaining results are scaled proportionally).
     * @param {boolean} [includeBoxes]
     * @param {boolean} [includeTokens]
     * @param {boolean} [includeModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Rqd2QuerierApi
     */
    Rqd2QuerierApi.prototype.structuredSearch = function (rqid, userId, correlationId, entities, threshold, matches, sortBy, includeBoxes, includeTokens, includeModel, options) {
        var _this = this;
        return (0, exports.Rqd2QuerierApiFp)(this.configuration).structuredSearch(rqid, userId, correlationId, entities, threshold, matches, sortBy, includeBoxes, includeTokens, includeModel, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return Rqd2QuerierApi;
}(base_1.BaseAPI));
exports.Rqd2QuerierApi = Rqd2QuerierApi;
